import { atom, useAtom } from 'jotai';
import { EquipmentPartModel } from '../../data/types';
import { useEffect } from 'react';
import DatabaseAssetsMethods from '../../data/database.assets.methods';
import { inspectionDB } from '../../data/database.structure';
import useMergedState from '../../hooks/useMergedState';

interface RollerAssemblyState {
  error?: string;
  equipmentPart?: EquipmentPartModel;
}

interface RollerAssemblyProps {
  inspectionCategoryTypeId?: string;
  externalId?: string;
  sideName?: string;
  partCategory?: string;
  partName?: string;
  equipmentPartId?: string;
  position?: string;
}

export const useRollerAssemblyHook = ({
  inspectionCategoryTypeId,
  externalId,
  sideName,
  partCategory,
  partName,
  equipmentPartId,
  position,
}: RollerAssemblyProps) => {
  const [state, setState] = useMergedState<RollerAssemblyState>({});

  useEffect(() => {
    async function getEquipment() {
      try {
        const assetMethods = new DatabaseAssetsMethods(inspectionDB);

        const equipmentPartIdNumber = Number(equipmentPartId);

        const partCategoryDefined = partCategory
          ?.split('-')
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))[0];

        const partNameDefined = partName
          ?.split('-')
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')
          .replace(/s$/, '');

        const equipmentPart = await assetMethods.getAssetEquipmentPartById(
          equipmentPartIdNumber,
          partCategoryDefined! == 'Sliders' ? 'Slider' : partCategoryDefined!,
          partNameDefined!,
        );

        if (!equipmentPart) {
          throw new Error('Equipment part not found');
        }
        setState({ error: undefined, equipmentPart });
      } catch (error) {
        setState({ error: error as string });
      }
    }

    if (externalId && sideName) {
      getEquipment();
    }
  }, [externalId, sideName, partCategory, equipmentPartId]);

  return { error: state.error, equipmentPart: state.equipmentPart };
};
